export default class ChangeNameViewModel {
    id: string = "";
    firstName: string | null = null;
    lastName: string | null = null;
}